<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-06 10:44:20
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-12-22 16:43:09
-->
<template>
  <div class="artical-detail">
    <div v-if="!loading && rowData.type !== 1" @click="handleLinkBbs" class="add-question">
      <img src="../../assets/wenda.png" class="edit-icon" alt="">
      <div>畅聊</div>
    </div>
    <div v-if="!loading" class="detail-top">
      <div v-if="!rowData.type" class="title">
        <!-- <span v-if="rowData.refinedFlag" class="boutique">精</span> -->
        {{rowData.title}}
      </div>
      <div class="top">
        <div class="avatar">
          <van-image
            @click="handlePersonal(rowData.userId)"
            round
            width="1rem"
            height="1rem"
            :src="rowData.userIconUrl"
          />
          <FansPendant v-if="rowData.userId" :userId="rowData.userId"/>
        </div>
        <div class="info">
          <div>
            <div class="name" @click="handlePersonal(rowData.userId)">
              <span>{{rowData.userName}}
                <span class="inner-box">{{authInfo && authInfo.delFlag !== 0 ? '(已离职)' : formatOrg(rowData.organizationFullName)}}</span>
              </span>
            </div>
            <div class="org">
              <span class="time">{{rowData.createTime}}</span>
              <span v-if="rowData.type === 0 && rowData.userErp === userInfo.erp && rowData.viewNum" style="color: #2D6FA5" @click="viewRecords">
                <van-icon name="eye-o" color="#2D6FA5"/>
                {{rowData.viewNum}}
              </span>
              <span v-else>
                <van-icon name="eye-o" />
                {{rowData.viewNum}}
              </span>
              <!-- <span v-if="openStatus" class="open-status">该内容已公开</span> -->
              <!-- <span>{{rowData.createTime}}</span> -->
            </div>
          </div>
          <div class="attentionWarp" v-if="rowData.userId > -1 && rowData.userErp !== userInfo.erp">
            <van-button
              @click="handleFollow(rowData.isAttention)"
              size="small"
              class="attentionBtn"
              :style="{
                background: !rowData.isAttention ? authInfo && authInfo.gender === 1
                              ? '#266bf6'
                              : '#f57575' : '',
                borderColor: !rowData.isAttention ? authInfo && authInfo.gender === 1
                              ? '#266bf6'
                              : '#f57575' : '#d9d9d9',
                color: !rowData.isAttention ? '#fff' : '#848484',
              }"
              :icon="!rowData.isAttention ? 'like-o' : ''"
              type="default">
              {{rowData.isAttention ? '已关注' : '粉Ta'}}
            </van-button>
          <div class="attentionFans">粉丝 {{rowData.fansNumber}}</div>
          </div>
        </div>
      </div>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
      <div class="detail-content">
        <div>
          <van-loading
            v-if="loading"
            size="24px"
            class="loading"
            vertical>
            加载中...
          </van-loading>
          <div class="detail-editor" v-else>
            <div v-if="rowData.type === 4">
              <div v-if="rowData.content" class="detail-codemirror-desc">
                {{rowData.content}}
              </div>
              <codemirror v-model="rowData.code" :options="options"></codemirror>
            </div>
            <template v-else>
              <div v-if="rowData.editorType === 1" ref="viewer" id="viewer" key="viewer"></div>
              <div v-else-if="rowData.type === 1" @click="handleClick" style="overflow: hidden">
                <div v-html="content"></div>
              </div>
              <div v-else @click="clickEditor">
                <Editor
                ref="editor"
                class="editor"
                v-model="rowData.content"
                :defaultConfig="editorConfig"
              />
              </div>
              <div v-if="rowData.type === 1 && imageList.length" class="bbs-image-list">
                  <img v-for="item in imageList" :key="item" :src="item"/>
              </div>
              <!--  投票 -->
              <div v-if="rowData.voteId > 0 && rowData.voteInfo" class="vote" @click.stop="() => {}">
                <div class="vote-header">
                  <div>{{rowData.voteInfo.name}}</div>
                  <span>{{rowData.voteInfo.totalPeople}}人已参与 {{ rowData.voteInfo.status === 1 ? '已结束' : `距离结束还有${rowData.voteInfo.validityDay}天` }}</span>
                </div>
                <div class="vote-finshed" v-if="(rowData.voteInfo.userVoteOptions && rowData.voteInfo.userVoteOptions.length && !rowData.voteInfo.remainVotes) || rowData.voteInfo.status === 1">
                  <div
                    v-for="item in rowData.voteInfo.options"
                    :key="item.id"
                    class="vote-option"
                    :style="{
                      background: `linear-gradient(to right, ${
                        rowData.voteInfo.userVoteOptions.includes(item.id)
                          ? 'rgba(80, 183, 255, 0.2)'
                          : 'rgba(153, 154, 170, 0.2)'
                      } 0%,${
                        rowData.voteInfo.userVoteOptions.includes(item.id)
                          ? 'rgba(80, 183, 255, 0.2)'
                          : 'rgba(153, 154, 170, 0.2)'
                      } ${getVoteWidth(item)}, white ${getVoteWidth(item)},white 100%)`,
                    }"
                  >
                    <!-- <div
                      class="vote-checked-bg"
                      :style="{
                              width: getVoteWidth(item),
                              backgroundColor: rowData.voteInfo.userVoteOptions.includes(item.id)
                                ? '#50b7ff'
                                : '#999aaa',
                            }"
                    ></div> -->
                    <div>
                      <van-image v-if="rowData.voteInfo.optionType === 'graphics'" :src="item.extraLinks[0]" lazy-load class="vote-item-image vote-finish-item-image" @click.stop="() => preViewVoteImage(item.extraLinks[0])"/>
                      {{item.name}}
                      <img src="./../../assets/duigou.png" class="vote-selected" v-if="rowData.voteInfo.userVoteOptions.includes(item.id)"/>
                    </div>
                    <span :style="{
                              color: rowData.voteInfo.userVoteOptions.includes(item.id) ? '#50b7ff' : '#999aaa', marginLeft: '8px', flexShrink: 0
                            }">{{item.totalVote}}票</span>
                  </div>
                </div>
                <div class="vote-pending" v-else>
                  <template v-if="rowData.voteInfo.multi === 1">
                    <van-checkbox-group v-model="voteResult">
                        <van-checkbox icon-size="14px" class="vote-checkbox" shape="square" v-for="option in rowData.voteInfo.options" :key="option.id" :name="option.id">
                          <van-image v-if="rowData.voteInfo.optionType === 'graphics'" :src="option.extraLinks[0]" lazy-load class="vote-item-image" @click.stop="() => preViewVoteImage(option.extraLinks[0])"/>
                          <span v-html="urlToLink(option.name)" class="vote-item-text"></span>
                        </van-checkbox>
                    </van-checkbox-group>
                  </template>
                  <template v-else>
                    <van-radio-group v-model="voteValue">
                      <van-radio icon-size="14px" class="vote-checkbox" v-for="option in rowData.voteInfo.options" :key="option.id" :name="option.id">
                        <van-image v-if="rowData.voteInfo.optionType === 'graphics'" :src="option.extraLinks[0]" lazy-load class="vote-item-image" @click.stop="() => preViewVoteImage(option.extraLinks[0])"/>
                        <span v-html="urlToLink(option.name)" class="vote-item-text"></span>
                      </van-radio>
                    </van-radio-group>
                  </template>
                </div>
                <template  v-if="(rowData.voteInfo.remainVotes || !rowData.voteInfo.userVoteOptions || !rowData.voteInfo.userVoteOptions.length) && rowData.voteInfo.status === 0">
                  <div class="vote-operate">
                    <div @click="handleVote">投票</div>
                  </div>
                  <div v-if="rowData.voteInfo.remainVotes" class="remainVotes">今日剩余投票次数:{{rowData.voteInfo.remainVotes}}</div>
                </template>
                
              </div>
            </template>

          </div>

          <div v-if="!loading" class="publish-time">
            <!-- <span>发布于 {{rowData.createTime}}</span>
            <span>阅读 {{rowData.viewNum}}</span> -->
            <div class="source-wrap">
              <div class="circle-wrap" v-if="rowData.forumId && forums.length">
                <div class="circle-item" v-for="item in rowData.forums" :key="item.id" @click="() => goCircleDetail(item.id)">
                  <img class="circle-icon" src="@/assets/circle-icon.png" />
                  <span class="circle-name">{{item.name}}</span>
                </div>
              </div>
              <div class="source-column">
                <span class="column" v-if="rowData.columnId">收录于专栏《<span @click="goColumnDetail">{{rowData.columnName}}</span>》</span>
                <span class="column dept-source" v-if="deptInfo.deptName">来自部门圈（{{deptInfo.deptName}}）</span>
              </div>
            </div>
            <div class="operate-btns">
              <span v-if="deptInfo.isOwner && !openStatus" @click="showOpenPopup = true" class="focus-btn">
                <span>设为公开</span>
              </span>
              <!-- <span v-if="!rowData.type" @click="handleCollect" class="collect-btn">
                <span>{{rowData.isFavor ? '已收藏' : '收藏'}}</span>
                {{rowData.collectNum}}
              </span> -->
              <span v-if="rowData.type" @click="handleFocus" class="focus-btn">
                <img src="../../assets/tixing.png"/>
                <span>{{rowData.isFocus ? '已关注' : '关注'}} {{rowData.focusNum}}</span>
              </span>
            </div>
            <!-- 文章作者信息 -->
            <div v-if="!rowData.type" class="auth-info-wrap">
              <div class="auth-info">
                <div class="avatar">
                  <van-image
                    @click="handlePersonal(rowData.userId)"
                    round
                    width="1rem"
                    height="1rem"
                    :src="rowData.userIconUrl"
                  />
                  <FansPendant v-if="rowData.userId" :userId="rowData.userId"/>
                </div>
                <div class="auth-info-name">
                  <div class="name" @click="handlePersonal(rowData.userId)">{{rowData.userName}}</div>
                  <span v-if="authInfo">{{authInfo.postNum || 0}}篇文章</span>
                </div>
                <van-button
                  @click="handleFollow(rowData.isAttention)"
                  size="small"
                  class="attentionBtn"
                  :style="{
                    background: !rowData.isAttention ? authInfo && authInfo.gender === 1
                                  ? '#266bf6'
                                  : '#f57575' : '',
                    borderColor: !rowData.isAttention ? authInfo && authInfo.gender === 1
                                  ? '#266bf6'
                                  : '#f57575' : '#d9d9d9',
                    color: !rowData.isAttention ? '#fff' : '#848484',
                  }"
                  :icon="!rowData.isAttention ? 'like-o' : ''"
                  type="default">
                  {{rowData.isAttention ? '已关注' : '粉Ta'}}
                </van-button>
              </div>
              <span v-if="!rowData.type" @click="handleCollect" class="collect-btn">
                <span>{{rowData.isFavor ? '已收藏' : '收藏'}}</span>
                {{rowData.collectNum}}
              </span>
            </div>

          </div>
          
        </div>

        <RecommendPostList v-if="recommendPostList && recommendPostList.length" :list="recommendPostList"/>

        <div id='comment-wrap'>
          <div v-if="list.length" class="comment-list">
            <div  class="comment-title">
              <div>全部评论
              <span>{{totalReplyNum}}</span></div>
              <div  class="comment-order-radio" v-if="rowData.type === 1">
                <span :actived="commentOrderBy === 1" @click="commentOrderBy = 1">默认</span>
                <span :actived="commentOrderBy === 0" @click="commentOrderBy = 0">最新</span>
              </div>
            </div>
            <van-list
                style="margin-top:10px;padding-bottom:10px;"
                v-if="shareCommentList.length"
              >
                <DetailComment
                  :list="shareCommentList"
                  :total="1"
                  :author="rowData.userErp"
                  :first="true"
                  :id="id"
                  :showMore="false"
                  @shareComment="shareComment"
                  @refresh="handleShareDetailRefresh"
                  @updateList="handleShareUpdate"
                  @comment="handleComment"
                  @refreshComment="() => {}" />
            </van-list>
            <van-loading
              v-if="replyLoading"
              size="24px"
              class="reply-loading"
              vertical>
              加载中...
            </van-loading>
            <template v-if="hotList && hotList.length">
              <van-divider :hairline="false">最热回复</van-divider>
              <van-list
                style="margin-top:10px;padding-bottom:10px;"
              >
                <DetailComment
                  :list="hotList"
                  :total="totalCount"
                  :author="rowData.userErp"
                  :first="true"
                  :id="id"
                  :showMore="false"
                  @shareComment="shareComment"
                  @refresh="handleDetailRefresh"
                  @updateList="handleUpdate"
                  @comment="handleComment"
                  @refreshComment="fetchCommentList" />
              </van-list>
            </template>
            <van-divider v-if="hotList && hotList.length" :hairline="false">最新回复</van-divider>
            <van-list
              v-model="replyLoading"
              :finished="finished"
              @load="onLoad"
              style="margin-top:10px;padding-bottom:50px;"
            >
              <DetailComment
                :list="newList"
                :total="totalCount - hotList.length"
                :author="rowData.userErp"
                :first="true"
                :id="id"
                @refresh="handleDetailRefresh"
                @shareComment="shareComment"
                @updateList="handleUpdate"
                @comment="handleComment"
                @refreshComment="fetchCommentList" />
            </van-list>
          </div>
          <div v-if="!loading" class="empty" :style="list.length ? {height:'50px'} : {height: '100px'}">
            <span v-if="totalCount === 0">暂无评论</span>
            <span v-if="list.length === totalCount &&  totalCount > 0">没有更多内容了</span>
            <!-- {{list.length === totalCount &&  totalCount > 0 ? '没有更多内容了' : '暂无评论'}} -->
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <div class="footer">
      <Comment
        :rowData="rowData"
        :totalReplyNum="totalReplyNum"
        :shareLinkKey="shareLinkKey"
        :onlyReal="onlyReal"
        source="detail"
        ref="commentRef"
        @refresh="handleRefresh" />
    </div>
    <van-popup v-model="showOpenPopup" position="bottom" style="padding-bottom: 12px">
      <div class="open-cell open-cell-first" @click="openChat">
        <div class="open-cell-title">社区所有人可见</div>
        <div class="open-cell-desc">设置后畅聊社区页所有人可查看，且不可再转为仅部门可见</div>
      </div>
      <div class="open-cell" @click="setCanShareLink">
        <div class="open-cell-title">转发链接所有人可见<span v-if="shareLinkKey">(已设置)</span></div>
        <div class="open-cell-desc">设置后部门管理员转发该畅聊所有人可查看，且不可再转为仅部门可见</div>
      </div>
    </van-popup>
    <van-popup v-model="showViewRecords" lazy-render  position="bottom" style="height: 80%">
      <ViewRecordsView :postId="rowData.id" :showViewRecords="showViewRecords"/>
    </van-popup>
    
  </div>
</template>

<script>
import Comment from './components/comment.vue'
import DetailComment from './components/detailComment.vue'
import api from '../../api'
import { mapActions, mapState } from 'vuex'
// import VueMarkdownEditor, { xss } from '@kangc/v-md-editor';
import { ImagePreview, Toast } from 'vant';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
// import { Viewer } from '@toast-ui/vue-editor';
import '@toast-ui/chart/dist/toastui-chart.css';
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
import chart from '@toast-ui/editor-plugin-chart';
import 'prismjs/themes/prism.css';
import '@toast-ui/editor-plugin-code-syntax-highlight/dist/toastui-editor-plugin-code-syntax-highlight.css';
// Import prismjs
import Prism from 'prismjs';
import codeSyntaxHighlight from '@toast-ui/editor-plugin-code-syntax-highlight';
import { Editor } from '@wangeditor/editor-for-vue'

import '@toast-ui/editor-plugin-table-merged-cell/dist/toastui-editor-plugin-table-merged-cell.css';
import tableMergedCell from '@toast-ui/editor-plugin-table-merged-cell';

import uml from '@toast-ui/editor-plugin-uml';
import { codemirror } from "vue-codemirror";
import '../../utils/cm-setting.js';
import FansPendant from '../../components/fansPendant.vue';
import { urlToLink, getLinkUrl } from '@/utils/lib';
import ViewRecordsView from './components/viewRocords.vue';
import RecommendPostList from './components/recommendPostList.vue';

export default {
  data() {
    return {
      loading: false,
      isLoading: false,
      rowData: {},
      authInfo: null,
      onlyReal: false,
      editorOption: {
        readOnly: true
      },
      showOpenPopup: false,
      list: [],
      shareCommentList: [],
      totalReplyNum: 0,
      totalCount: 0,
      viewInstance: null,
      editorConfig: {
        readOnly: true,
        MENU_CONF: {
          fontSize: {
            fontSizeList: [
              '12px',
              '14px',
              '16px',
              '18px',
              '20px',
              '22px',
              '24px',
              '26px',
              '28px',
              '30px',
              '32px',
              '34px',
              '36px',
              '42px',
              '48px',
              '72px',
            ],
          },
        }
      },
      replyLoading: false,
      pageParams: {
        page: 1,
        pageSize: 10
      },
      finished: false,
      voteResult: [],
      voteValue: undefined,
      commentOrderBy: 1,
      openStatus: false,
      deptInfo: {},
      shareLinkKey: '',
      urlToLink,
      showViewRecords: false,
      recommendPostList: []
    }
  },
  components: {
    Comment,
    DetailComment,
    Editor,
    codemirror,
    FansPendant,
    ViewRecordsView,
    RecommendPostList
  },
  watch: {
    commentOrderBy: {
      handler() {
        this.fetchCommentList('init')
      }
    },
    deptInfo: {
      immediate: true,
      deep: true,
      handler(dept) {
        if (dept?.orgCode && dept?.orgCode !== '0') {
          this.getOpenStatus();
        }
      }
    },
    id: {
      handler() {
        this.init();
      }
    }
  },
  computed: {
    forums() {
      return this.rowData?.forums?.filter((item) => item.orgCode === '0') || []
    },
    options() {
      return {
        line: true,
        theme: "blackboard", // 主题
        readOnly: true, // 只读
        lineNumbers: true, // 是否显示行号
        mode: this.rowData?.codeLanguage,
      }
    },
    content() {
      const newContent = this.rowData?.content?.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, '');
      return newContent;
    },
    imageList() {
      if (this.rowData?.content) {
        const imgReg = /<img.*?(?:>|\/>)/gi;
        // eslint-disable-next-line no-useless-escape
        const srcReg = /(http|https):\/\/[\'\"]?([^\'\"]*)[\'\"]?/i;
        // 图片链接
        const imgList = (this.rowData?.content.match(imgReg) || []).map((o) => {
          let imgLink = o.match(srcReg);
          if (imgLink && imgLink.length) {
            let item = imgLink[0];
            return item.substring(0, item.length - 1);
          }
          return null;
        });
        const uploadImage = this.rowData?.postAttachmentList?.map((item) => item.url) || [];
        return [...imgList, ...uploadImage];
      }
      return []
    },
    id() {
      const search =  new URL(window.location.href).searchParams
      const id = location.pathname.includes('/articleDetail') ? search.get('id') : this.$route.params.id;
      return id;
    },
    position() {
      const query = new URL(window.location.href).searchParams;
      return query.get('position') || '';
    },
    hotList() {
      return  this.list?.filter((o) => o.replyType === 1) || [];
    },
    newList() {
      return  this.list?.filter((o) => o.replyType !== 1);
    },
    ...mapState(['userInfo'])
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    if (this.rowData.type === 0) {
      const params = { postId: +this.rowData.id}
      api.newPostView(params, {status: 2})
    }
  },
  methods: {
    ...mapActions(['updateUserInfoList']),
    init() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.fetchArticleDetail().then(res => {
        if (res.del_flag !== 2) {
          this.updatePostView()
          // if (res.type === 0) {
          //   this.fetchPrevious()
          // }
        }
        if (this.position) {
          this.$nextTick(() => {
            const el = document.getElementById('comment-wrap');
            el.scrollIntoView();
          })
        }
        if (res.type === 0) {
          this.getRecommendPostList(res.labelList);
        }
      })
      this.fetchShareCommentList(true);
      this.fetchCommentList();
      this.handleBack()
    },
    clickEditor() {
      // const topicList = this.editor.getElemsByType('topic')
    },
    viewRecords() {
      this.showViewRecords = true;
    },
    async getShareChatLinkKeyByPostId() {
      const { data, code } = await api.getShareChatLinkKeyByPostId(this.rowData.id)
      if (code === 200) {
        this.shareLinkKey = data;
      }
    },
    async getOpenStatus() {
      const { data, code } = await api.getBBSOpenStatus({
        postId: this.rowData.id,
        forumId: this.deptInfo.id
      })
      if (code === 200) {
        this.openStatus = data;
        if (!data) {
          this.getShareChatLinkKeyByPostId();
        }
      }
    },
    async setCanShareLink() {
      if (this.shareLinkKey) {
        this.showOpenPopup = false;
        return;
      }
      const { data , code} = await api.getShareChatLinkKey({
        postId: this.rowData.id,
        forumId: this.deptInfo.id
      });
      if (code === 200) {
        this.shareLinkKey = data;
        this.showOpenPopup = false;
        Toast.success('设置成功')
      }
    },
    async openChat() {
      await api.setBBsOpen({
        postId: this.rowData.id,
        forumId: this.deptInfo.id
      })
      this.openStatus = true;
      this.showOpenPopup = false;
      Toast.success('设置成功')
    },

    async getRecommendPostList(labelList) {
      const params = {
        pageSize: 3,
        current: 1,
        type: 0,
        // labelIds: labelList.map((o) => o.id),
        postId: this.id,
      }
      const labelRecommend = await api.getRecommendPostList({
        ...params,
        labelIds: JSON.parse(JSON.stringify(labelList))?.map((o) => o.id)?.join(',')
      });
      const personalRecommend = await api.getRecommendPostList({
        ...params,
        entrance: 1
      });
      const _list = [
      ...(personalRecommend?.data?.slice(0, 2) || []),
      ...(labelRecommend?.data?.slice(0, 1) || []),
    ];
    const _hotArticleList = _list?.filter((item, index) => _list?.findIndex(i => i?.id === item?.id) === index);
      this.recommendPostList = _hotArticleList || []
    },
    goColumnDetail() {
      this.$router.push({ name: 'columnDetail', params: { id: this.rowData.columnId } })
    },
    goCircleDetail(id) {
      this.$router.push({ name: 'circleDetail', params: { id, refreshFlag: 1 } })
    },
    handleLinkBbs() {
      this.$router.push({ name: 'articleList', query: { type: 1, refresh: 1} })
    },
    async handleVote() {
      const { data, code } = await api.vote({
        voteId: this.rowData.voteId,
        postId: this.rowData.id,
        optionId: this.rowData.voteInfo.multi === 1 ? [...this.voteResult] : [this.voteValue]
      })
      if (code === 200) {
        Toast.success('投票成功')
        this.$set(this.rowData, 'voteInfo', data)
      }
    },
    getVoteWidth(option) {
      const { totalVote } = option;
      console.log(option)
      return Math.abs(Number((totalVote / this.rowData.voteInfo.totalPeople) * 100).toFixed(0)) + '%';
    },
    // async fetchPrevious() {
    //   const data = await api.fetchPrevious({
    //     postId: this.id,
    //   })
    //   console.log(data)
    // },
    handleClick(e) {
      if (e?.target && e.target.getAttribute('data-w-e-type') === 'topic') {
        const topic = e.target.innerText.replaceAll('#', '');
        this.$router.push({ name: 'topicDetail', query: { topic: encodeURIComponent(topic) } })
        return;
      }
    },
    handleBack() {
      const _this = this
      let options = {
          disabled: true,
          callback: function() {
            if (window.history.length > 1) {
              _this.$router.go(-1)
            } else {
              const query = {
                type: _this.rowData.type === 1 ? 1 : 0
              };
              if (_this.rowData.type === 1 && _this.rowData?.forums?.length) {
                if (_this.rowData?.forums[0]?.orgCode && _this.rowData?.forums[0]?.orgCode !== '0') {
                  query.orgCode = _this.rowData?.forums[0]?.orgCode;
                }
                
              }
              _this.$router.replace({ name: 'articleList', query })
            }
          }
      }
      window.jme.browser.setGoBackDisabled(options)
    },    
    handlePersonal(id) {
      if (id === -1) return;
      this.$router.push({ name: 'personal', query: { id } })
    },
    async getCircleBbsIsReal(forums) {
      if (forums?.length) {
        const forumIds = forums.map((item) => item.id);
        const data = await api.getCircleBbsIsReal({forumIds : forumIds.join()});
        console.log(data)
        for (let key in (data?.data || {})) {
          if (data.data[key]) {
            this.onlyReal = true;
          }
        }
      }
    },
    fetchArticleDetail() {
      return new Promise((resolve) => {
        const params = { id: this.id }
        if (this.$route?.query?.shareLinkKey) {
          params.shareKey = this.$route?.query?.shareLinkKey
        }
        if (!this.isLoading) {
          this.loading = true
        }
        api.getArticleDetail(params).then(res => {
          this.loading = false
          this.isLoading = false
          const { code, data } = res;
          if (code === 200) {
            this.rowData = data;
            if (data.userId && data.userId !== -1) {
              this.updateUserInfoList(data.userId)
              this.getAuthInfo(data.userId);
            }
            if (data.type === 1) {
              this.getCircleBbsIsReal(data.forums);
            }
            const dept = this.rowData?.forums?.find((item) => item.orgCode && item.orgCode !== '0');
            const nameList = dept?.name?.split('-') || [];
            this.deptInfo = dept ? {
              ...dept,
              deptName: dept.name === '集团T-PaaS' ? dept.name : nameList[nameList.length - 1]
            } : {}
            resolve(data)
            this.$nextTick(() => {
              if (data.editorType === 1) {
                this.viewInstance = new Viewer({
                  el: document.querySelector('#viewer'),
                  plugins: [chart, [codeSyntaxHighlight, { highlighter: Prism }], tableMergedCell, uml],
                  height: '600px',
                  initialValue: data.content
                });
              }
              this.handleEditorReady()
            })
          }
        }).catch(({message}) => {
          Toast({
              type: 'fail',
              message: message || '该讨论帖不存在或已删除，请查看社区其它内容~',
              onClose: () => {
                this.$router.replace({ name: 'articleList' })
              }
            });
        })
      })
    },
    async getAuthInfo(userId) {
      const { data } = await api.getUserDetail({
        id: userId
      });
      this.authInfo = data || null;
    },
    onLoad() {
      this.pageParams.page++
      this.fetchCommentList()
    },
    fetchShareCommentList(init = false) {
      if (!this.$route?.query?.replyId) return;
      const params = {
        postId: this.id,
        page: 1,
        pageSize: 1,
        replyId: this.$route?.query?.replyId
      };
      api.postReplyList(params).then(res => {
        const { code, data } = res
        if (code === 200) {
          this.shareCommentList = data || [];
          if (data?.length && init) {
            const el = document.getElementById('comment-wrap');
            el.scrollIntoView();
          }
        }
      })
    },
    fetchCommentList(init = false, scrollTop) {
      const params = {
        postId: this.id,
        ...this.pageParams,
      }
      if (this.rowData.type === 1 || location.pathname.includes('/bbs')) {
        params.condition = this.commentOrderBy;
      }
      if (init) {
        this.pageParams.page = 1;
        params.page = 1;
        this.finished = false
      }
      this.replyLoading = true
      api.postReplyList(params).then(res => {
        const { code, data, totalCount, totalReplyNum } = res;
        const filterList = data.filter((item) => {
          if (!this.shareCommentList?.length) {
            return true;
          }
          return item.id !== this.shareCommentList[0]?.id;
        })
        this.replyLoading = false;
        if (code === 200) {
          if (this.pageParams.page > 1) {
            this.list = this.list.concat(filterList)
          } else {
            this.list = filterList || []
          }
          const userIds = filterList?.map((item) => item.userId);
          if (userIds?.length) {
            this.updateUserInfoList(userIds.join())
          }
          if (this.list.length >= totalCount) {
            this.finished = true
          }
          this.totalReplyNum = totalReplyNum
          this.totalCount = totalCount
          if (scrollTop === 'init') {
            const el = document.getElementById('comment-wrap');
            el.scrollIntoView();
          }else if (scrollTop) {
            this.$nextTick(() => {
              document.body.scrollTop = document.documentElement.scrollTop = scrollTop
            })
          }
        }
      })
    },
    updatePostView() {
      // api.postView(this.$route.query.id)
      const { shareId } = this.$route.query
      const params = { postId: +this.id }
      if (shareId) {
        params.shareUserId = +shareId
      }
      const query = {};
      if (this.rowData?.type === 0) {
        query.status = 1;
      }
      api.newPostView(params, query)
    },
    handleShareUpdate(id, childList, isReplay = false) {
      this.shareCommentList = this.shareCommentList.map(item => {
        if (item.id === id) {
          if (isReplay) {
            item.childrenList.result = [...childList]
          } else {
            item.childrenList.result.push(...childList)
          }
        }
        return item
      })
    },
    handleUpdate(id, childList, isReplay = false) {
      this.list = this.list.map(item => {
        if (item.id === id) {
          if (isReplay) {
            item.childrenList.result = [...childList]
          } else {
            item.childrenList.result.push(...childList)
          }
        }
        return item
      })
    },
    handleComment(params) {
      this.$refs.commentRef.handleChat(true, params)
    },
    handleRefresh(val, scrollTop) {
      if (val) {
        if (scrollTop === 'share') {
          Object.assign(this.rowData, {  sharedNum: val.sharedNum })
          return;
        }
        let up
        let upNum
        if (val.isUp === '踩') {
          up = val.isUp === '踩' ? -1 : 1
          upNum = val.upNum
        } else {
          up = val.isUp === 1 ? -1 : 1
          upNum = val.isUp === 1 ? val.upNum - 1 : val.upNum + 1 
        }
        Object.assign(this.rowData, { isUp: up, upNum })
      } else {
        // this.fetchArticleDetail()
        this.fetchCommentList(true, scrollTop);
        this.fetchShareCommentList();
      }
    },
    handleShareDetailRefresh(val) {
      this.shareCommentList = this.shareCommentList.map(item => {
        if (item.id === val) {
          item.upOrDown = item.upOrDown > 0 ? -1 : 1;
          item.upNum = item.upOrDown < 0 ? item.upNum - 1 : item.upNum + 1;
          // item.childrenList.result.push(...childList)
        } else {
          if (item.childrenList.result) {
            item.childrenList.result.map(it => {
              if (it.id === val) {
                it.upOrDown = it.upOrDown > 0 ? -1 : 1;
                it.upNum = it.upOrDown < 0 ? item.upNum - 1 : item.upNum + 1;
              }
              return it
            })
          }
        }
        return item
      })
    },
    handleDetailRefresh (val) {
      this.list = this.list.map(item => {
        if (item.id === val) {
          item.upOrDown = item.upOrDown > 0 ? -1 : 1;
          item.upNum = item.upOrDown < 0 ? item.upNum - 1 : item.upNum + 1;
          // item.childrenList.result.push(...childList)
        } else {
          if (item.childrenList.result) {
            item.childrenList.result.map(it => {
              if (it.id === val) {
                it.upOrDown = it.upOrDown > 0 ? -1 : 1;
                it.upNum = it.upOrDown < 0 ? item.upNum - 1 : item.upNum + 1;
              }
              return it
            })
          }
        }
        return item
      })
      // this.fetchCommentList()
    },
    onRefresh() {
      this.isLoading = true
      this.fetchArticleDetail()
      this.fetchCommentList(true)
    },
    handleEditorReady() {
      const ctx = document.getElementsByClassName('detail-editor')[0]
      const imgs = ctx?.getElementsByTagName('img');
      const allImgUrl = []
      for (let i = 0; i < imgs.length; i++) {
        const item = imgs[i]
        allImgUrl.push(item.src)
        item.onclick = () => {
          if (item.getAttribute('data-href')) {
            const dataHref = item.getAttribute('data-href');
            const url = getLinkUrl(dataHref);
            if (typeof url === 'string') {
              window.jme.browser.openUrl({
                url
              });
            } else {
              this.$router.push({ name: url.name, params: { id: url.id } })
            }
          } else {
            ImagePreview({
              images: allImgUrl,
              startPosition: i
            })
          }
          
        }
        const parentNode = item.parentNode
        parentNode.style.textIndent = '0em'
      }
      const links = ctx?.getElementsByTagName('a');
      for (let i = 0; i < links.length; i++) {
        const item = links[i];
        item.onclick = (e) => {
          e.preventDefault();
          const url = getLinkUrl(item.href);
          if (typeof url === 'string') {
            window.jme.browser.openUrl({
              url
            });
          } else {
            this.$router.push({ name: url.name, params: { id: url.id } })
          }
        }
      }
    },
    preViewVoteImage(src) {
      ImagePreview([src])
    },
    formatOrg(val) {
      if (val) {
        let ary = val.split('-')
        let filterAry = ary.slice(1, 3)
        return filterAry.join('-')
      }
    },
    handleCollect() {
      const params = { id: +this.id }
      api.collectPost(params).then(res => {
        const { code, data: { collectNum, isFavor } } = res
        const favor = isFavor === '收藏' ? 1 : 0
        if (code === 200) {
          this.$set(this.rowData, 'collectNum', collectNum)
          this.$set(this.rowData, 'isFavor', favor)
        }
      })
    },
    handleFocus() {
      const params = { id: +this.id }
      api.focusPost(params).then(res => {
        const { code, data: { isFocus, focusNum } } = res
        const focus = isFocus === '关注' ? 1 : 0
        if (code === 200) {
          this.$set(this.rowData, 'isFocus', focus)
          this.$set(this.rowData, 'focusNum', focusNum)
        }
      })
    },
    handleFollow(flag) {
      if (flag) {
        api.cancelFollow(this.rowData.userId).then((res) => {
          if (res.code === 200) {
            Toast.success('取消关注成功')
            this.$set(this.rowData, 'isAttention', 0)
            this.$set(this.rowData, 'fansNumber', this.rowData.fansNumber - 1)
          }
        })
        return
      }
      api.follow(this.rowData.userId).then((res) => {
        if (res.code === 200) {
          Toast.success('关注成功')
          this.$set(this.rowData, 'isAttention', 1)
          this.$set(this.rowData, 'fansNumber', this.rowData.fansNumber + 1)
        }
      })
    },
    shareComment(commentItem) {
      const { title, info, id, contentText, type } = this.rowData
      const msg = info || contentText;
      const shareId = this.$route.query.shareId ? this.$route.query.shareId : this.userInfo.id;
      let _type = 'article';
      let _title = title;
      switch (type) {
        case 1:
          _type = 'bbs';
          _title = '神灯畅聊'
          break;
        case 4:
          _type = 'codeShow';
          _title = '代码文化-CodeShow'
          break;
      }
      const shareLinkKey = this.shareLinkKey ? `&shareLinkKey=${this.shareLinkKey}` : ''
      const url = `http://sd.jd.com/${_type}/${id}?shareId=${shareId}&isHideShareButton=1${shareLinkKey}&replyId=${commentItem.id}`
      const options = {
        shareData: {
          title: _title,
          content: msg,
          url,
          icon: 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-02-28-17-07uAVeSgG0YYEUaxf.png',
        },
        typeList: ['JDMESession', 'CopyLink'],
        callback: ({status, shareType}) => {
          console.log(status, shareType)
          if (+status === 0) {
            if (this.source === 'list') {
              this.updatePostView();
            }
            if (shareType === 'JDMESession') {
              this.shareSuccess();
            }
          }
          
        }
      }
      window.jme.share.shareCustom(options);
    }
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.avatar {
  position: relative;
}
.detail-codemirror-desc {
  margin-bottom: 12px;
  font-size: 14px;
}
.vote-selected {
  height: 13px;
  width: 13px;
  margin-left: 8px;
}
  .add-question {
    position: fixed;
    right: 2px;
    z-index: 100;
    // opacity: 0.9;
    background: #f9fbff;
    top: 45vh;
    border-radius: 4px;
    padding: 4px;
    // width: 40px;
    // height: 40px;
    box-shadow: 2px 2px 4px 2px #f5f8fc, 0 3px 6px 0 #f5f8fc;
    color: #3477E9;
    // padding-bottom: constant(safe-area-inset-bottom);
    // padding-bottom: env(safe-area-inset-bottom);
  }
  .edit-icon {
    width: 20px;
    height: 20px;
  }
.artical-detail {
  min-height: calc(100vh - 80px);
  margin-bottom: 50px;
  padding-bottom: 24px; 
  /deep/ .ql-toolbar {
    display: none;
  }
  /deep/ .ql-container {
    border: none;
  }
  /deep/ .ql-editor {
    font-size: 14px;
  }
  /deep/ .van-pull-refresh {
    user-select: text;
    -webkit-user-select: text;
  }
}
.vote {
  text-align: left;
  border: 1px solid #efeff2;
  padding: 8px;
  border-radius: 4px;
  margin-top: 12px;
  &-header {
    & > div {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    & > span {
      color: #606266;
      font-size: 12px;
    }
  }
  &-option {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin: 8px 4px;
    padding: 8px 16px;
    background-color: #fbfbfb;
    border-radius: 4px;
    font-size: 14px;
  }
  &-checked-bg {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    opacity: 0.2;
  }
  &-checkbox {
    font-size: 14px;
    // display: block;
    // & > div {
      margin: 8px 4px;
      padding: 8px 16px;
      background-color: #fbfbfb;
      border-radius: 4px;
      font-size: 14px;
    // }
  }
  &-operate {
    text-align: center;
    padding: 8px 16px 0px 16px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    & > div {
      padding: 2px 16px;
      color: #fff;
      background-color: #2695f1;
      border-radius: 50px;
      cursor: pointer;
      font-size: 14px;
      &:hover {
        background-color: #50b7ff;
      }
    }
  }

}
.name {
  color: #232930;
  text-align: left;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  // align-items: center;
}
.detail-top {
  padding: 16px 16px 8px 16px;
  background: #fff;
}
.top {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.org {
  width: 100%;
  display: inline-flex;
  // justify-content: space-between;
  font-size:12px;
  color:#606266;
}
.info {
  margin-left: 6px;
  color: #606266;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  font-size: 14px;
}
.footer {
  position: fixed;
  bottom: 0;
  background: #fff;
  height: 64px;
  width: 100%;
  display: flex;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.comment-list {
  margin-top: 8px;
  padding: 10px 16px 16px 16px;
  font-size: 14px;
  text-align: left;
  font-weight: 500;
  background: #fff;
}
.loading {
  height: 100vh;
  background: #fff;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.reply-loading{
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  width: 100%;
  position: absolute;
  z-index: 200;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 24px;
}
.empty {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
}
.detail-content {
  min-height:70vh;
}
.boutique {
  width: 24px;
  height: 24px;
  margin-right: 4px;
  color: #eb6105;
  font-size: 14px;
  text-align: center;
  background-color: #f3db8b;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.publish-time {
  background: #fff;
  color: #606266;
  font-size: 12px;
  padding: 10px 0.4rem;
  // display: flex;
  // justify-content: space-between;
  overflow: hidden;
  align-items: flex-end;
}
.column {
  color: #909399;
  & > span {
    color: #2695f1;
  }
}
.dept-source {
  color: #909399;
  // margin-left: 16px;
  text-align: right;
  & > span {
    color: #909399;
    font-size: 12px;
  }
}
.open-status {
  margin-left: 16px;
}
.collect-btn {
  display: inline-block;
  color: #2695F1;
  font-size: 12px;
  border: 1px solid #2695F1;
  padding: 2px 4px;
  border-radius: 4px;
  transform: scale(0.9);
  flex-shrink: 0;
}
.operate-btns {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 4px;
}
.focus-btn {
  display: inline-flex;
  align-items: center;
  color: #2695F1;
  font-size: 12px;
  border: 1px solid #2695F1;
  padding: 2px 4px;
  border-radius: 4px;
  transform: scale(0.9);
  flex-shrink: 0;
  & > img {
    height: 12px;
    margin-right: 4px;
  }
}
.detail-editor {
  background:#fff;
  font-size: 14px;
  color: #232930;
  text-align: left;
  padding: 0 16px;
  /deep/ .toastui-editor-contents, /deep/ .w-e-text-container {
    overflow: hidden;
    word-break: break-all;
  }
  /deep/ .toastui-editor-contents p, /deep/ .toastui-editor-contents pre {
    white-space: break-spaces;
    color: #232930;
    font-family: PingFang SC, Avenir, Helvetica, Arial, sans-serif;
  }
  /deep/ .toastui-editor-contents h1, /deep/ .toastui-editor-contents h2, /deep/ .toastui-editor-contents h3,  /deep/ .toastui-editor-contents h4, /deep/ .toastui-editor-contents h5, /deep/ .toastui-editor-contents h6 {
    border-bottom: 0;
    color: #232930;
    font-family: PingFang SC, Avenir, Helvetica, Arial, sans-serif;
  }
  /deep/ .toastui-editor-contents img {
    margin: 0;
    object-fit: cover;
    height: auto!important;
    width: auto;
  }
  /deep/ .toastui-editor-contents h1 {
    text-indent: 0!important;
  }
  /deep/ .w-e-image-container {
    max-width: 100%;
    height: auto !important;
  }
  /deep/ .w-e-text-container [data-slate-editor] .w-e-image-container {
    margin: 0;
    img {
    max-width: 100% !important;
    height: auto !important;
    vertical-align: middle;
    // cursor: zoom-in;
  }
  } 
}
/deep/ .w-e-text-container [data-slate-editor] pre>code {
  white-space: break-spaces;
  word-break: break-all;
}
/deep/ .w-e-text-container [data-slate-editor] table {
  width: max-content;
}
.inner-box {
  font-size:12px;
  color:#606266;
}
.time {
  margin-right: 20px;
}
.attentionWarp {
  flex-shrink: 0;
}
.attentionBtn {
  // width: 54px;
  padding: 0 8px;
  height: 20px;
  border-radius: 12px;
  flex-shrink: 0;
}
.attentionFans {
  font-size: 12px;
  color: #606266;
  margin-top: 2px;
}
.comment-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  .comment-order-radio {
    display: flex;
    border-radius:4px;
    overflow: hidden;
    background: #f4f4f4;
    padding: 2px;
    & > span {
      padding: 2px 12px;
      border-radius: 2px;
      &[actived='true'] {
        background: #fff;
      }
    }
  }
}
.bbs-image-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  // margin-bottom: 14px;
  & > img {
      width: 100%;
      height: 100px;
      object-fit: contain;
      background: #fbfbfb;
  }
}
.open-cell {
  text-align: left;
  padding: 8px;
  &-first {
    border-bottom: 1px solid #fbfbfb;
  }
  &-title {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 2px;
    span {
      font-size: 13px;
      color: #909399;
    }
  }
  &-desc {
    font-size: 12px;
    color: #909399;
  }
}
.source-column {
  margin-top: 8px;
}
.circle-wrap {
  display: flex;
  align-items: center;
  text-align: left;
  .circle-item {
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-right: 8px;
    border: 1px solid #2695F1;
    border-radius: 35px;
    padding: 0 4px;
    color: #2695F1;
  }
  .circle-icon {
    height: 10px;
    width: 10px;
    margin-right: 2px;
    border-radius: 4px;
  }
  .circle-name {
    white-space: nowrap;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.source-wrap {
  text-align: left;
  flex: 1;
  overflow: hidden;
}
  .vote-item-image {
    height: 40px;
    width: 40px;
    flex-shrink: 0;
    margin:0 12px 0 8px;
    background: #f6f6f6;
    border-radius: 4px;
    overflow: hidden;
  }
  .vote-finish-item-image {
    margin: 0 12px 0 0;
  }
  /deep/ .van-checkbox__label, /deep/ .van-radio__label {
    display: flex;
    align-items: center;
  }
  /deep/ .van-checkbox, /deep/ .van-radio {
    align-items: center;
  }
  .vote-option {
    display: flex;
    align-items: center;
    & > div {
      display: flex;
      align-items: center;
    }
  }
  .remainVotes {
    font-size: 12px;
    text-align: center;
    color: #606266;
    margin-top: 8px;
  }
  .auth-info-wrap {
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
  }
  .auth-info {
    display: grid;
    grid-column-gap: 12px;
    align-items: center;
    grid-template-columns: auto auto auto;
  }
  .auth-info-name {
    & > div {
      font-size: 13px;
    }
    & > span {
      font-size: 12px;
      color: #909399;
    }
  }
</style>
